/* =============================================
   SENCHADO CART — お茶のお供 quick-add
   - [data-sc-quickadd][data-variant-id] クリックで /cart/add.js
   - ドロワーがあれば sections を渡して renderContents（hero.js と同方式）
   - カートページでは reload で反映
   - cart:updated を dispatch（ヘッダー数バッジ同期に乗る）
   ============================================= */
(function () {
  'use strict';

  // 二重ロード防止（恒久ガード）:
  // cart_type=='drawer' の本番では cart-drawer(layout, 全ページ描画) と /cart の main-cart-items が
  // 両方このスクリプトを <script> し得る構成のため、ガードなしだと下の click / cart:updated
  // listener が2回登録され、quick-add 1クリックで /cart/add.js が2回POSTされる。
  // 兄弟の senchado-gift-wrap.js(__scGiftWrapInit) / senchado-shipping.js(window.SenchadoShipping)
  // と同じ冪等ガードで、複数 <script> でも配線を1回に限定する。
  if (typeof window !== 'undefined') {
    if (window.__scCartInit) return;
    window.__scCartInit = true;
  }

  async function quickAdd(btn) {
    // 再入防止: 同一クリックで複数 listener が走っても /cart/add.js は1回だけにする。
    // 送信中はボタンが disabled になるため、2発目はここで抜ける（数量2追加を防ぐ）。
    if (btn.disabled) return;
    // 先行発売ロック（監査 H9/M系 横断）: Cart Function無効のため、クロスセル quick-add でも
    // disabled が外されたら必ずここで /cart/add.js を止める。
    if (btn.dataset.earlyLocked === 'true') return;
    const vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '追加中...';

    // クリックされたボタンの所属で挙動を決める:
    // - ドロワー内のボタン → ドロワーを再描画（同方式 hero.js）
    // - カートページ(#main-cart-items)上のボタン → reload でページの行・小計・送料を更新
    const inDrawer = btn.closest('cart-drawer');
    const onCartPage = !!document.getElementById('main-cart-items');
    const drawer = inDrawer ? inDrawer : onCartPage ? null : document.querySelector('cart-drawer');
    const body = { items: [{ id: Number(vid), quantity: 1 }] };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('add failed');
      const data = await res.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      btn.textContent = '追加しました';

      if (drawer) {
        try {
          const sec = data && data.sections;
          if (sec && sec['cart-drawer'] && sec['cart-icon-bubble'] && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
          } else if (typeof drawer.open === 'function') {
            drawer.open();
          }
        } catch (_) {
          /* non-fatal */
        }
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = original;
        }, 1500);
      } else {
        // カートページ: 小計・行・送料状態を反映するためリロード
        window.location.reload();
      }
    } catch (err) {
      btn.disabled = false;
      btn.textContent = original;
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sc-quickadd]');
    if (!btn) return;
    e.preventDefault();
    quickAdd(btn);
  });

  // ===== 送料無料コードの「適用済み」検知 =====
  // 送料無料割引は cart.discount_codes(cart.js) にのみ現れ Liquid からは読めないため、
  // JS で /cart.js と data-sc-ship-code を突き合わせ、適用済みなら表示を「適用しました」に切替＋進捗を隠す。
  async function syncShip30Applied() {
    const blocks = document.querySelectorAll('[data-sc-ship-code]');
    if (!blocks.length) return;
    let codes = [];
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      codes = cart.discount_codes || [];
    } catch (_) {
      return;
    }
    const applied = new Set(codes.filter((d) => d && d.applicable).map((d) => d.code));
    let anyApplied = false;
    blocks.forEach((b) => {
      const code = b.getAttribute('data-sc-ship-code');
      const isApplied = code && applied.has(code);
      b.classList.toggle('is-applied', !!isApplied);
      if (isApplied) {
        anyApplied = true;
        const rec = b.closest('.sc-cart-rec');
        if (rec) rec.classList.add('is-ship-free');
      }
    });
    if (anyApplied) {
      // カートページのサマリー進捗は不要（レジで送料無料）。送料行には適用済みを明記。
      document.querySelectorAll('.sc-summary__ship-msg, .sc-summary__bar').forEach((e) => {
        e.style.display = 'none';
      });
      document.querySelectorAll('.sc-summary').forEach((s) => {
        if (s.querySelector('[data-sc-ship-applied-note]')) return;
        const note = document.createElement('p');
        note.setAttribute('data-sc-ship-applied-note', '');
        note.className = 'sc-summary__ship-applied';
        note.textContent = '🎟 送料無料コード適用中（レジで送料無料）';
        s.insertBefore(note, s.firstChild ? s.firstChild.nextSibling : null);
      });
    } else {
      // 適用が外れたとき（コードを外した・カートが空になった・対象外になった）に
      // 「適用中」が残ると、送料無料でないのに無料だと読ませてしまう。必ず元に戻す。
      // DOM が差し替わっていれば下の2行は空振りするだけ（冪等）。
      document.querySelectorAll('[data-sc-ship-applied-note]').forEach((n) => n.remove());
      document.querySelectorAll('.sc-summary__ship-msg, .sc-summary__bar').forEach((e) => {
        e.style.display = '';
      });
    }
  }

  document.addEventListener('DOMContentLoaded', syncShip30Applied);
  document.addEventListener('cart:updated', syncShip30Applied);

  // ===== S6: 数量変更のあとも「適用中」を保つ =====
  // Dawn の数量変更（assets/cart.js:153-231）は **DOMイベントを撒かず pubsub でしか知らせない**。
  // しかも `.js-contents` をサーバLiquidの描画で丸ごと差し替えるため、上の2行だけでは
  // 「🎟 送料無料コード適用中」が消え、「あと¥Xで送料無料」と送料¥670が復活したまま
  // リロードするまで戻らなかった（監査 S6・audit-cart-ttj-2026-07-29.md）。
  // publish は差し替えの **後** に呼ばれる（cart.js:191-228）ので、ここで貼り直せばよい。
  // 兄弟モジュールは既に同じブリッジを張っている（senchado-gift-wrap.js:910 / senchado-header.js:235）。
  // このファイルだけが配線漏れだった。
  function bridgeCartUpdatePubSub() {
    if (typeof subscribe !== 'function') return false;
    if (typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncShip30Applied);
    return true;
  }
  // constants.js / pubsub.js は layout/theme.liquid:61-62 で先に defer 読みされるため
  // 通常はここで張れる。読み込み順が変わった場合の保険として DOMContentLoaded でも試す。
  if (!bridgeCartUpdatePubSub()) {
    document.addEventListener('DOMContentLoaded', bridgeCartUpdatePubSub);
  }
})();
